// Auto-generated bundle for es translations
import activity from './activity.json';
import admin from './admin.json';
import app from './app.json';
import auth from './auth.json';
import balances from './balances.json';
import claimLink from './claimLink.json';
import common from './common.json';
import currencies from './currencies.json';
import dashboard from './dashboard.json';
import emails from './emails.json';
import errors from './errors.json';
import expenses from './expenses.json';
import friends from './friends.json';
import groups from './groups.json';
import importNs from './import.json';
import invitations from './invitations.json';
import landing from './landing.json';
import members from './members.json';
import mobile from './mobile.json';
import notifications from './notifications.json';
import pages from './pages.json';
import profile from './profile.json';
import reports from './reports.json';
import settings from './settings.json';
import settlements from './settlements.json';
import social from './social.json';
import success from './success.json';

export default {
  activity,
  admin,
  app,
  auth,
  balances,
  claimLink,
  common,
  currencies,
  dashboard,
  emails,
  errors,
  expenses,
  friends,
  groups,
  import: importNs,
  invitations,
  landing,
  members,
  notifications,
  pages,
  profile,
  reports,
  settings,
  settlements,
  social,
  success,
  mobile,
};
